import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiRItem } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiRItemDialogData {
  items?: ApiRItem[];
}

@Component({
  selector: 'app-multi-ritem-dialog',
  templateUrl: './multi-ritem-dialog.component.html',
  styleUrls: ['./multi-ritem-dialog.component.css'],
  standalone: false,
})
export class MultiRitemDialogComponent implements OnInit {

  //名称×言語数
  items: ApiRItem[] = [];
  itemsFormGroup!: FormGroup;
  itemsArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiRitemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiRItemDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.items = this.data.items!;
    if (!this.items) {
      this.items = [];
    }
    this.createForm();
    this.itemsArrayControl = this.itemsFormGroup.get('items') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.itemsFormGroup.disable();
    }
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.items.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let item = '';
      let trans_item = '';
      for (const value of this.items) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          item = value.item;
          trans_item = value.trans_item;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          item: [item, [Validators.required]],
          transItem: [trans_item],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          item: [item],
          transItem: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.itemsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        items: arrayControl
      }
    );
  }

  //更新ボタン
  addItems(): void {
    if (this.itemsFormGroup.valid) {
      let items = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.itemsArrayControl.controls[index];
        items.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            item: ctrl.get('item')!.value,
            trans_item: ctrl.get('transItem')!.value,
          }
        )
      }
      this.items = items;
      this.dialogRef.close(this.items);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.itemsFormGroup.get('autoAllTrans')!.value;
    for (const item of this.itemsArrayControl.controls) {
      item.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.itemsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const item of this.itemsArrayControl.controls) {
      if (!item.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.itemsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
